export default __webpack_public_path__ + "static/media/ambience.4f139a67.png";